const AudiocastsView = () => {
  return <div>AudiocastsView</div>;
};

export default AudiocastsView;
